import React from 'react';

export enum ScrollDirection {
    Left = 'next',
    Right = 'previous',
}

type ScrollReturnType = ScrollDirection | undefined;

const useScrollDirection = () => {
    const lastScrollLeft = React.useRef(0);
    const scrollDirection = React.useRef<ScrollReturnType>(undefined);

    const handleScroll = React.useCallback((event: React.SyntheticEvent<HTMLElement, Event>): ScrollReturnType => {
        const currentScrollLeft = (event.target as HTMLElement).scrollLeft;

        if (currentScrollLeft > lastScrollLeft.current) {
            scrollDirection.current = ScrollDirection.Right;
        }
        if (currentScrollLeft < lastScrollLeft.current) {
            scrollDirection.current = ScrollDirection.Left;
        }
        lastScrollLeft.current = currentScrollLeft;

        return scrollDirection.current;
    }, []);

    return { handleScroll };
};

export default useScrollDirection;
